import React from "react";
import styles from "./index.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setSelectedCollection, setSelectedHeader, setSelectedScreen } from "../../../redux/slice/dashboardSlice";
import toggleIcon from "../../../assets/icons/toggle.png";
import DefaultImg from "../../Profile/DefaultImg";
import arrow from "../../../assets/wall-icons/back_arrow.png";

const index = ({ title }) => {
    const { profileImg } = useSelector((state) => state.root.auth.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { selectedHeader, selectedScreen } = useSelector((state) => state.root.dashboard);
    const handleClick = () => {
        if (selectedScreen) {
            return;
        }
        if (selectedHeader === "LinkInBio") {
            dispatch(setSelectedHeader("Collections"));
        } else {
            dispatch(setSelectedHeader("LinkInBio"));
        }
    };

    const handleBack = () => {
        dispatch(setSelectedCollection(null));
        dispatch(setSelectedScreen(null));
        history.back();
    };
    return (
        <div className={styles.navbar}>
            {selectedScreen ? (
                <img src={arrow} className={styles.backButton} onClick={handleBack} />
            ) : (
                <span style={{ width: "25px" }}> </span>
            )}
            <div className={styles.titleContainer} onClick={handleClick}>
                <div className={styles.title}>
                    {selectedScreen === "collection"
                        ? "Collections"
                        : selectedScreen === "linkinbio"
                          ? "Builder"
                          : selectedHeader === "LinkInBio"
                            ? "Link in Bio"
                            : "Store"}
                </div>
                {!selectedScreen && <img src={toggleIcon} className={styles.titleImage} />}
            </div>
            <div
                className={styles.userProfile}
                onClick={() => {
                    navigate("/profile");
                }}
            >
                {profileImg ? (
                    <img
                        src={profileImg ? profileImg : ""}
                        alt="profile-icon"
                        className={styles.profileImg}
                        style={{ borderColor: "black" }}
                    />
                ) : (
                    <DefaultImg height={"30px"} width={"30px"} fontSize={"12px"} radius={"50%"} margin={"0"} />
                )}
            </div>
        </div>
    );
};

export default index;
